import gql from 'graphql-tag'

export default gql`
  query GetMarketplaceProductFacets(
    $categoryPath: [String!]!
    $filter: MarketplaceProductsFilter
    $query: String
  ) {
    category: marketplaceCategory(
      path: $categoryPath
      filter: $filter
      query: $query
    ) {
      path {
        code
        title
      }
      title
      children {
        path {
          code
          title
        }
        title
      }
      content {
        categoryPath
        pageTitle
        h1Header
        metaDescription
        blurbTitle
        blurbBody
      }
      productTypes
    }
    productFacets: marketplaceProductFacets(
      categoryPath: $categoryPath
      filter: $filter
      query: $query
    ) {
      id
      type
      title
      options {
        id
        label
        group
      }
      searchFieldPlaceholder
    }
  }
`
